import { Component, inject } from '@angular/core';

import { DynamicDialogRef } from 'primeng/dynamicdialog';

import { DashboardService } from '../../services/dashboard.service';

@Component({
    selector: 'qw-widget-selector',
    templateUrl: './widget-selector.component.html',
    styleUrls: ['./widget-selector.component.scss'],
})
export class WidgetSelectorComponent {

    private readonly modal = inject(DynamicDialogRef);
    private readonly service = inject(DashboardService);

    public datasets$ = this.service.getDataSets();
    public selectedSet = null;
    public selectedSetIdx: null | number = null;
    public selectedWidget = null;
    public selectedWidgetIdx: null | number = null;

    public selectSet(idx: number, set) {
        if (idx === this.selectedSetIdx) {
            return;
        }
        this.selectedSet = set;
        this.selectedSetIdx = idx;
        this.selectedWidget = null;
        this.selectedWidgetIdx = null;
    }

    public selectWidget(idx: number, widget) {
        if (idx === this.selectedWidgetIdx) {
            return;
        }
        this.selectedWidget = widget;
        this.selectedWidgetIdx = idx;
    }

    public save() {
        this.modal.close({
            caption: 'Test',
            dataset: this.selectedSet,
            widget: this.selectedWidget,
        });
    }
}
